import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToSection = () => {
  const location = useLocation();
  const prevLocationRef = useRef(location);

  useEffect(() => {
    // Prevent browser's default scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const hash = location.hash;
    
    // Check if pathname changed (page navigation)
    const isPageNavigation = prevLocationRef.current.pathname !== location.pathname;
    
    if (hash && hash.length > 1) {
      const element = document.querySelector(hash);
      if (element) {
        // Use smooth scrolling only for same-page hash navigation
        // Use instant scrolling for page navigation with hash
        const behavior = isPageNavigation ? 'auto' : 'smooth';
        
        // Use a longer timeout for mobile devices
        const timeout = window.innerWidth <= 768 ? 300 : 100;
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior,
            block: 'start'
          });
        }, timeout);
      }
    } else {
      // If no hash, scroll to top of page (instant for page navigation)
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    
    // Update the ref for next comparison
    prevLocationRef.current = location;
  }, [location]);
};
